(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbc-experience"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  const goTo = (element) => {
    const top = element.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({top, behavior: motionPreference.matches ? 'auto' : 'smooth'});
  };
  function init(root) {
    root.querySelectorAll('.nbc--home').forEach(section => {
      if (section.dataset.enhanced) return;
      section.dataset.enhanced = 'true';
      const form = section.querySelector('[data-nbc-finder]');
      const shell = section.querySelector('[data-nbc-result]');
      const copyNode = section.querySelector('[data-nbc-copy]');
      if (form && shell && copyNode) {
        const words = JSON.parse(copyNode.textContent);
        const cards = [...section.querySelectorAll('[data-nbc-candidates] [data-tags]')];
        const error = form.querySelector('[data-nbc-error]');
        const brewInputs = [...form.querySelectorAll('input[name="brew"]')];
        const syncBrewOptions = () => {
          const drink = form.querySelector('input[name="drink"]:checked')?.value;
          const milkDrink = drink === 'milk' || drink === 'both';
          brewInputs.forEach(input => {
            const blocked = milkDrink && ['pour-over', 'aeropress'].includes(input.value);
            input.disabled = blocked;
            input.closest('label')?.toggleAttribute('aria-disabled', blocked);
            if (blocked && input.checked) input.checked = false;
          });
        };
        form.querySelectorAll('input[name="drink"]').forEach(input => input.addEventListener('change', syncBrewOptions));
        syncBrewOptions();
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (!form.checkValidity()) {
            error.textContent = words.validation;
            form.reportValidity();
            return;
          }
          error.textContent = '';
          const data = new FormData(form), taste = data.get('taste'), brew = data.get('brew'), drink = data.get('drink');
          const ranked = cards.filter(card => card.dataset.available !== 'false').map(card => {
            const tags = new Set((card.dataset.tags || '').split(',').map(tag => tag.trim()));
            // Only tasting notes count as flavour evidence, never farm narrative.
            const notes = (card.dataset.description || '').split(/tasting notes?\s*:/i)[1]?.trim() || '';
            const approved = tags.has('finder-approved');
            const milkDrink = drink === 'milk' || drink === 'both';
            const supportsBrew = !(milkDrink && brew === 'pour-over') &&
              (brew === 'other' || tags.has(brew));
            const supportsDrink = drink === 'black' ? tags.has('black') :
              milkDrink && tags.has('milk-friendly') && (drink !== 'both' || tags.has('black'));
            const flavour = approved && tags.has(taste) ? 5 : 0;
            return {card, notes, score: flavour, eligible: supportsBrew && supportsDrink && flavour > 0};
          }).filter(item => item.eligible).sort((a,b) => b.score - a.score || a.card.dataset.title.localeCompare(b.card.dataset.title));
          const best = ranked[0];
          if (!best) {
            shell.hidden = true;
            error.textContent = words.noMatch;
            error.tabIndex = -1;
            error.focus({preventScroll:true});
            goTo(form);
            return;
          }
          const match = best.card;
          const alternatives = shell.querySelector('[data-nbc-alternatives]');
          alternatives.replaceChildren();
          const tied = ranked.filter(item => item.score === best.score && item !== best);
          if (tied.length) {
            const label = document.createElement('p');
            label.textContent = words.tied;
            alternatives.append(label);
            tied.forEach(item => {
              const link = document.createElement('a');
              link.href = item.card.dataset.url;
              link.textContent = item.card.dataset.title;
              link.style.display = 'block';
              alternatives.append(link);
            });
          }
          shell.querySelector('[data-nbc-result-title]').textContent = match.dataset.title;
          shell.querySelector('[data-nbc-result-price]').textContent = match.dataset.price;
          shell.querySelector('[data-nbc-result-link]').href = match.dataset.url;
          const image = shell.querySelector('[data-nbc-result-image]');
          if (match.dataset.image) { image.src = match.dataset.image; image.alt = match.dataset.title; image.hidden = false; }
          else { image.removeAttribute('src'); image.hidden = true; }
          shell.querySelector('[data-nbc-result-reason]').textContent = words.reason.replace('[taste]',words[taste]).replace('[brew]',words[brew]).replace('[drink]',words[drink]) + (best.notes ? ' ' + words.notes + ' ' + best.notes : '');
          shell.hidden = false;
          const title = shell.querySelector('[data-nbc-result-title]');
          title.tabIndex = -1;
          title.focus({preventScroll:true});
          goTo(shell);
        });
        shell.querySelector('[data-nbc-revise]')?.addEventListener('click', () => {
          form.querySelector('input:checked')?.focus({preventScroll:true});
          goTo(form);
        });
      }
      section.querySelectorAll('[data-nbc-motion]').forEach(scene => {
        const button = scene.querySelector('[data-nbc-pause]');
        let paused = false, visible = false;
        const update = () => {
          scene.dataset.playing = String(!paused && visible && !document.hidden && !motionPreference.matches);
          button.hidden = motionPreference.matches;
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
          button.querySelector('span').textContent = paused ? '▷' : 'Ⅱ';
        };
        button.addEventListener('click', () => { paused = !paused; update(); });
        const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, {threshold:.1});
        observer.observe(scene);
        document.addEventListener('visibilitychange', update);
        motionPreference.addEventListener('change', update);
        section.addEventListener('shopify:section:unload', () => {
          observer.disconnect();
          document.removeEventListener('visibilitychange', update);
          motionPreference.removeEventListener('change', update);
        }, {once:true});
        update();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbc-subscription-selector"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-nbc-sub]').forEach((section)=>{const sync=()=>{const productForms=[...document.querySelectorAll('product-form form[action*="/cart/add"],form[action*="/cart/add"]')];const values={"Brew method":section.querySelector('[name="nbc_brew"]:checked')?.value,"Flavour preference":section.querySelector('[name="nbc_flavour"]:checked')?.value,"Grind preference":section.querySelector('[name="nbc_grind"]:checked')?.value};productForms.forEach((form)=>{Object.entries(values).forEach(([key,value])=>{let input=form.querySelector(`[data-nbc-property="${key}"]`);if(!input){input=document.createElement('input');input.type='hidden';input.name=`properties[${key}]`;input.dataset.nbcProperty=key;form.appendChild(input);}input.value=value||'';});});};section.addEventListener('change',sync);section.querySelector('[data-nbc-sub-continue]')?.addEventListener('click',(event)=>{event.preventDefault();sync();document.querySelector('[id^="ProductInfo-"]')?.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});});sync();});

  } catch(e) { console.error(e); }
})();
})();
